import { DSSelect } from '@vr/ds-react';
import { useRelatorios } from '../pages/Relatorios/RelatoriosContext';
import { useState } from 'react';

const Select = ({
    dataTestId,
    label,
    placeholder,
    options,
    type
}: {
    dataTestId: string;
    label: string;
    placeholder: string;
    options: { label: string; value: string; }[];
    type: string;
}) => {
    const { setFiltros } = useRelatorios();
    const [selectedOption, setSelectedOption] = useState(null);

    const handleSelect = (option: any) => {
        if (option) {
            setFiltros({ [type]: option });
            setSelectedOption(option);
        }
    };

    return (
        <DSSelect
            data-testid={dataTestId}
            label={label}
            placeholder={placeholder}
            options={options}
            onSelect={handleSelect}
            selected={selectedOption}
        />
    )
};

export default Select;